import { textFieldTheme as textTheme } from '@clds/text-field-old';
export const numberFieldTheme = {
    buttons: {
        margin: (props) => props.theme.spacing.xs,
        padding: (props) => props.theme.spacing.xxs,
        background: textTheme.background.color.base,
    },
};
